import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "firstNameInput", "lastNameInput", "emailInput", "submitButton"];
  static values = {
    open: { type: Boolean, default: false }
  };

  connect() {
    if (this.openValue) {
      this.showModal();
    }

    this.validate();
  }

  open(event) {
    event.preventDefault();
    this.showModal();
  }

  showModal() {
    Modal.getOrCreateInstance(this.modalTarget).show();
  }

  modalShown() {
    if (this.hasFirstNameInputTarget) {
      this.firstNameInputTarget.focus();
    }

    this.validate();
  }

  modalHidden() {
    this.openValue = false;
    this.validate();
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = !this.formValid();
  }

  formValid() {
    if (!this.hasModalTarget) return false;

    const firstName = this.hasFirstNameInputTarget ? this.firstNameInputTarget.value.trim() : "";
    const lastName = this.hasLastNameInputTarget ? this.lastNameInputTarget.value.trim() : "";
    const email = this.hasEmailInputTarget ? this.emailInputTarget.value.trim() : "";
    const roleSelected = this.modalTarget.querySelector('input[name="company_member[role]"]:checked');
    const accessLevelInput = this.modalTarget.querySelector('[name="company_member[access_level]"]');
    const accessLevel = accessLevelInput ? accessLevelInput.value.trim() : "";

    return firstName !== "" &&
      lastName !== "" &&
      email !== "" &&
      roleSelected !== null &&
      accessLevel !== "";
  }
}
